import React, { CSSProperties } from 'react';
import { X } from 'react-feather';
import SideNavContent from './sideNavContent';

export type TabletSideNavDrawerProps = {
  /** Whether the drawer is open (i.e. sidebar is NOT collapsed on tablet) */
  isOpen: boolean;
  logoSrc: string;
  logoStyle: CSSProperties;
  /** Called when the backdrop or the close button is clicked */
  onClose: () => void;
};

const TabletSideNavDrawer: React.FC<TabletSideNavDrawerProps> = ({
  isOpen,
  logoSrc,
  logoStyle,
  onClose,
}) => {
  return (
    <>
      {/* Backdrop */}
      <div
        className={`fixed inset-0 bg-black/40 transition-opacity duration-300 ${
          isOpen
            ? 'opacity-100 pointer-events-auto'
            : 'opacity-0 pointer-events-none'
        }`}
        style={{ zIndex: 49 }}
        onClick={onClose}
        aria-hidden="true"
      />

      {/* Slide-in drawer panel */}
      <div
        className={`fixed top-0 left-0 flex flex-col h-screen px-4 py-2 bg-white transition-transform duration-300 shadow-2xl rounded-r-sm ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
        style={{ width: '220px', zIndex: 50 }}
      >
        {/* Logo row + close button — always pinned at the top, never scrolls */}
        <div className="flex items-center justify-between w-full shrink-0">
          <img
            src={logoSrc}
            alt="pozytron logo"
            className="max-w-[138px] transition-transform duration-500 ease-in-out"
            style={logoStyle}
          />
          <button
            type="button"
            onClick={onClose}
            className="p-2 rounded-lg text-neutral-60 hover:text-neutral-10 hover:bg-neutral-95 transition-colors shrink-0"
            aria-label="Zamknij menu"
          >
            <X size={20} />
          </button>
        </div>

        {/* Nav items – always fully expanded in the drawer. The only
            scrollable region; grows to fill the space left over by the logo
            and illustration, so a scrollbar only appears when the nav items
            themselves don't fit that space. */}
        <div className="flex-1 min-h-0 overflow-y-auto overscroll-contain mt-[37px]">
          <SideNavContent isIconOnly={false} />
        </div>

        {/* Illustration — always pinned at the bottom, its height is always
            reserved so it never gets squeezed by the nav list above. */}
        <img
          src="/navBarIllastration.svg"
          alt="pozytron logo"
          className="shrink-0"
        />
      </div>
    </>
  );
};

export default TabletSideNavDrawer;
